import axios from "axios";
import { authHeader } from "./authHeader";


const API_URL = process.env.REACT_APP_API_URL;

const PYTON_API_URL = process.env.REACT_APP_RAG_URL || "http://127.0.0.1:4001";

// Create Quote
const createQuote= (formData) => {
    const response= axios.post(API_URL + '/api/quotes',formData, { headers: authHeader()});
    return response;
}

// Get Quote
const getQuote= (params) => {
    const response= axios.get(API_URL + '/api/quotes', {
        params: params, 
        headers: authHeader()
    });
    return response;
}

// Get Quote By Id
const getQuoteByServiceId = (params, q_id) => {
    const response= axios.get(API_URL + `/api/quotes/service/${q_id}`, {
        params: params, 
        headers: authHeader()
    });
    return response;
}

// Get Quote By Id
const getQuoteById = (q_id) => {
    const response= axios.get(API_URL + `/api/quotes/${q_id}`, {
        headers: authHeader()
    });
    return response;
}

// Update Quote
const updateQuote= (q_id, formData) => {
    const response= axios.put(API_URL + `/api/quotes/${q_id}`,formData, {
        headers: authHeader()
    });
    return response;
}

// PYTHON API

// Create B2B Lead Template
const createB2bLeadPython = (formData) => {
    const response= axios.post(PYTON_API_URL + '/process-data/',formData, { headers: authHeader()});
    return response;
}

const QUOTEAPI = {createQuote, getQuote, getQuoteByServiceId, getQuoteById, updateQuote, createB2bLeadPython };

export default QUOTEAPI;